// installed dependencies
import { createContext } from 'react';

// store dependencies
import UIStore from '../stores/UIStore';
import AuthStore from '../stores/authStore';
import DashboardStore from '../stores/DashboardStore';
import ProviderStore from '../stores/ProviderStore';
import AuctionStore from '../stores/AuctionStore';
import * as EndpointStore from '../stores/EndpointStore';
import APIWebSocketStore from '../stores/APIWebSocketStore';
import ProductsStore from '../stores/ProductsStore';
import AuctionTranscriptDataStore from '../stores/AuctionTranscriptDataStore';
import ProxyBidStore from '../stores/ProxyBidsStore';
import ProductImagesStore from '../stores/ProductImageStore';
import MembersStore from '../stores/MembersStore';
import EngineToolStore from '../stores/EngineToolStore';
const endpointStore = EndpointStore;
const authStore = new AuthStore();
const providerStore = new ProviderStore();
const auctionStore = new AuctionStore();
const dashboardStore = new DashboardStore();
const productsStore = new ProductsStore();
const auctionTranscriptDataStore = new AuctionTranscriptDataStore();
const proxyBidStore = new ProxyBidStore();
const productImagesStore = new ProductImagesStore();
const membersStore = new MembersStore();
const engineToolStore = new EngineToolStore();
const apiWebSocketStore = new APIWebSocketStore(
  endpointStore,
  authStore,
  dashboardStore,
  membersStore,
);

const uiStore = new UIStore(apiWebSocketStore);

const storesContext = createContext({
  APIWebSocketStore: apiWebSocketStore,
  UIStore: uiStore,
  EndpointStore: endpointStore,
  AuthStore: authStore,
  DashboardStore: dashboardStore,
  ProviderStore: providerStore,
  AuctionStore: auctionStore,
  ProductsStore: productsStore,
  AuctionTranscriptDataStore: auctionTranscriptDataStore,
  ProxyBidStore: proxyBidStore,
  ProductImagesStore: productImagesStore,
  MembersStore: membersStore,
  EngineToolStore: engineToolStore,
});

export default storesContext;
